/* eslint-env browser */
import * as ActionTypes from 'actions';

const initialState = {
  email: '',
  isLoading: false,
  data: {},
  auth_token: '',
  user_id: '',
  rememberMe: true,
};

export default function(state = initialState, action = {}) {
  const { email, response, type, rememberMe } = action;

  switch (type) {
  case ActionTypes.LOGOUT_REQUEST: {
    const keepState = { rememberMe: state.rememberMe };

    if (state.rememberMe) {
      keepState.email = state.email;
    }
    return Object.assign({}, initialState, keepState);
  }

  case ActionTypes.LOGIN_INIT:
    return Object.assign({}, state, { email, rememberMe });

  case ActionTypes.LOGIN_REQUEST:
    return Object.assign({}, state, { email, rememberMe, isLoading: true });

  case ActionTypes.LOGIN_SUCCESS:
  case ActionTypes.LOGIN_VIA_AUTH_SUCCESS:
  case ActionTypes.LOGIN_VALIDATE_SUCCESS: {
    const { auth_token, user_id, ...data } = response;

    window.react_ga.set({ userId: `${window.ORG_NAME}--${user_id}` });

    return Object.assign({}, state, {
      email: data.email,
      isLoading: false,
      data,
      user_id,
      auth_token,
    });
  }

  case ActionTypes.LOGIN_FAILURE:
    return Object.assign({}, state, { isLoading: false });

  case ActionTypes.LOGIN_VALIDATE_REQUEST:
    return Object.assign({}, state, { isLoading: true });

  case ActionTypes.LOGIN_VALIDATE_FAILURE:
    if (state.rememberMe) {
      return Object.assign({}, state, { auth_token: '', isLoading: false });
    }
    return Object.assign({}, initialState);

  case ActionTypes.SET_LOGIN_DATA:
    console.log('test');
    const { auth_token, user_id, ...data } = action.payload;

    window.react_ga.set({ userId: `${window.ORG_NAME}--${user_id}` });

    return Object.assign({}, state, {
      email: data.email,
      isLoading: false,
      data,
      user_id,
      auth_token,
    });

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/auth.js